import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";
import IWorkOrderStatusModel from "interfaces/Response/IWorkOrderStatusModel";

function mapWorkOrderStatusToWorkOrderStatusViewModel(
  workOrderStatus: IWorkOrderStatusModel
): IWorkOrderStatusViewModel {
  const workOrderStatusViewModel: IWorkOrderStatusViewModel = {
    workOrderReference: workOrderStatus.workOrderReference ?? "",
    slaEnd: workOrderStatus.slaEnd ? new Date(workOrderStatus.slaEnd) : undefined,
    status: workOrderStatus.status,
    lastUpdatedTimestamp: workOrderStatus.lastUpdatedTimestamp ? new Date(workOrderStatus.lastUpdatedTimestamp) : undefined,
    regionId: workOrderStatus.regionId,
    regionName: workOrderStatus.regionName,
    hwrcSiteName: workOrderStatus.hwrcSiteName,
    regionHwrcSiteSortOrder: `${workOrderStatus.hwrcSiteName}, ${workOrderStatus.regionName}`,
    disposalSiteName: workOrderStatus.disposalSiteName ?? "",
    raisedBy: workOrderStatus.raisedBy ?? "",
    raisedByTimestamp: workOrderStatus.raisedByTimestamp ? new Date(workOrderStatus.raisedByTimestamp) : undefined,
    collectorId: workOrderStatus.collector?.id,
    collectorIsVehicle: workOrderStatus.collector?.isVehicle,
    collectorName: workOrderStatus.collector?.collectorName ?? "",
    collectorType: workOrderStatus.collector?.collectorType ?? "",
    containerId: workOrderStatus.container?.id ?? undefined,
    containerSize: workOrderStatus.container?.size ?? undefined,
    containerAboveThreshold: workOrderStatus.container?.aboveThreshold ?? undefined,
    containerWasteTypeId: workOrderStatus.container?.wasteTypeId ?? undefined,
    containerWasteType: workOrderStatus.container?.wasteType,
    containerName: workOrderStatus.container?.name ?? undefined
  };

  return workOrderStatusViewModel;
}

function mapContainerStatusesToContainerViewStatusModels(
  workOrderStatuses: IWorkOrderStatusModel[] | null
): IWorkOrderStatusViewModel[] {
  const containerStatusesViewModels: IWorkOrderStatusViewModel[] = [];

  if (workOrderStatuses) {
    workOrderStatuses.forEach((containerStatus): void => {
      containerStatusesViewModels.push(
        mapWorkOrderStatusToWorkOrderStatusViewModel(containerStatus)
      );
    });
  }

  return containerStatusesViewModels;
}

export {
  mapContainerStatusesToContainerViewStatusModels
};
